import { isApiError } from './isApiError';

export const getErrorCode = (error?: Error) => {
    return isApiError(error) ? error.code : '';
};
